export default __webpack_public_path__ + "static/media/avatar-constantin.749d0a16.png";